import React from 'react';
import { useSocket } from '../context/SocketContext';
import { useAuth } from '../context/AuthContext';

const ACCESS_LABELS = {
  camera: 'Camera',
  microphone: 'Microphone',
  screen_share: 'Screen Share'
};

export default function ChildAccessRequestModal() {
  const { user } = useAuth();
  const { pendingAccessRequest, respondToAccessRequest } = useSocket();

  if (user?.role !== 'child' || !pendingAccessRequest) return null;

  const requestType = ACCESS_LABELS[pendingAccessRequest.type] || pendingAccessRequest.type;
  const parentName = pendingAccessRequest.parentName || 'Parent';

  return (
    <div className="modal-overlay child-access-overlay" onClick={() => respondToAccessRequest({ approved: false })}>
      <div className="modal child-access-request-modal" onClick={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">Permission Request</div>
        </div>

        <p style={{ marginBottom: 12, color: 'var(--text-secondary)', lineHeight: 1.5 }}>
          {parentName} wants to access your {requestType.toLowerCase()}.
        </p>
        <p style={{ marginBottom: 20, color: 'var(--text-muted)', fontSize: 12 }}>
          You can allow once, deny, or trust this parent for faster access next time.
        </p>

        <div className="child-access-actions">
          <button className="btn btn-outline" onClick={() => respondToAccessRequest({ approved: false })}>
            Deny
          </button>
          <button className="btn btn-primary" onClick={() => respondToAccessRequest({ approved: true })}>
            Allow Once
          </button>
          <button className="btn btn-success" onClick={() => respondToAccessRequest({ approved: true, remember: true })}>
            Always Allow
          </button>
        </div>
      </div>
    </div>
  );
}
